import { fetchClientApiStep } from '../clientApiStep.helpers';

// eslint-disable-next-line import/prefer-default-export
export const fetchClientApiVerifyPotential = async ({
  api,
  body,
  submissionId,
  token,
}) =>
  fetchClientApiStep({
    api,
    body,
    submissionId,
    token,
    label: 'Verify solar potential',
  });
